import { CommonPageFilterSetting, CommonSearchCriteria } from "@app/shared/models/common-data.model";
import { IQueryStringGenerateor } from "./query-string-generator.interface";
import { ISpecificQueryCriteriaGenerator, SpecificQueryCriteriaGenerator } from "./query-string-generator.implementor";
import { SmartSearchHelper } from "@app/shared/components/smart-search-form/smart-search.helper";
import { Utilities } from "@app/shared/utils/utilities";
import { CommonFieldName } from "@app/shared/constants";

export class AdvancedQueryStringGenerateor implements IQueryStringGenerateor {
  protected queryCriteriaGenerator: ISpecificQueryCriteriaGenerator;
  constructor(queryCriteriaGenerator: ISpecificQueryCriteriaGenerator = new SpecificQueryCriteriaGenerator()) {
    this.queryCriteriaGenerator = queryCriteriaGenerator;
  }

  CreateQueryString(searchCriteria: CommonSearchCriteria[], pageFilterInfo?: CommonPageFilterSetting, specifiedQueryCountry?: string) {
    var searchCriteriaEx = Utilities.isEmptyString(specifiedQueryCountry) ? [...searchCriteria] :
      [...searchCriteria, { searchBy: CommonFieldName.country, searchValue: specifiedQueryCountry! } as CommonSearchCriteria];
    return SmartSearchHelper.CreateQueryString(searchCriteriaEx, pageFilterInfo, this.queryCriteriaGenerator.generate);
  }
}
